import React, { useEffect, useState } from "react";
import axios from "axios";
import { Upload, Trash2, Download } from "lucide-react";

const FileUploadHistory = (refresh) => {
  const [uploads, setUploads] = useState([]);
  const [pdfPreviews, setPdfPreviews] = useState({});
 
 
  const fetchUploads = async () => {
    try {
      const response = await axios.get("/server/ocrfunction/getbill");
      setUploads(response.data.data);
      console.log("uploads data from server", response.data.data);

     

    } catch (error) {
      console.error("Error fetching uploads:", error);
    }
  };
  useEffect(() => {
    

    fetchUploads();
   // Refresh every 60 seconds

 
  }, [refresh]);




  const Downloadimage = async (fileId) => {
    try {
      const filestore = window.catalyst.file;
      const folder = filestore.folderId("5053000000811702");
      const file = folder.fileId(fileId);
  
      const downloadResponse = await file.getDownloadLink();
      const downloadUrl = downloadResponse.content.download_url;
  
    
      window.open(downloadUrl, '_blank'); 
      
  
      console.log("Download URL:", downloadUrl);
    } catch (err) {
      console.error("Error downloading file:", err);
    }
  };
  const Deleteimage = async (fileId, rowId) => {
    const confirmed = window.confirm("Are you sure you want to delete this file? This action cannot be undone.");
    if (!confirmed) return;
   
    try {
 
   
      const response =  await axios.post("/server/ocrfunction/deletebill", {
        rowId: rowId,fileId: fileId
      }, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      console.log("Database row deleted:", response.data.message);
   
      fetchUploads(); 

    } catch (err) {
      console.error("Error deleting file or row:", err.message);
    
    }
  };
  
  
  

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-semibold mb-4">File Upload History</h1>
      <div className="overflow-x-auto rounded-lg shadow">
        <table className="min-w-full bg-white border border-gray-200">
          <thead className="bg-[#EF7320] text-white">
            <tr>
              <th className="text-center px-4 py-3">File Name</th>
              <th className="text-center px-4 py-3">Uploaded At</th>
              <th className="text-center px-4 py-3">Uploaded By</th>
              <th className="text-center px-4 py-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {uploads.map((file) => (
              <tr key={file.ROWID} className="border-t border-gray-200 hover:bg-gray-50">
                <td className="px-4 py-3 text-center">{file.file_name}</td>
                <td className="px-4 py-3 text-center">{new Date(file.CREATEDTIME).toLocaleDateString() }, On {  new Date(file.CREATEDTIME).toLocaleTimeString()}</td>
                <td className="px-4 py-3 text-center">{file.first_name}</td>
                <td className="px-4 py-3 text-center space-x-2">
                  <button className="text-green-600 hover:text-green-800" title="Re-upload" onClick={() => Downloadimage(file.img_id)}>
                    <Download className="w-5 h-5 inline" />
                  </button>
                  <button className="text-red-600 hover:text-red-800" title="Delete" onClick={() => Deleteimage(file.img_id, file.ROWID)}>
                    <Trash2 className="w-5 h-5 inline" />
                  </button>
                </td>
              </tr>
            ))}
            {uploads.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center py-4 text-gray-500">
                  No files uploaded yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
        {/* {Object.keys(pdfPreviews).map((rowId) => (
            <div key={rowId} className="mt-4">
            <h2 className="text-lg font-semibold">Image Preview</h2>
            <iframe
                src={pdfPreviews[rowId].url}
                title="PDF Preview"
                width="100%"
                height="500px"
                className="border border-gray-300 rounded-lg"
            ></iframe>
            </div>
        ))} */}
    </div>
  );
};

export default FileUploadHistory;
